import {useContext, useEffect, useState} from 'react'
import Search from '../../../../components/Search'
import {OrderAuditContext} from '../../context'
import Select from '../../../../components/Select/Select'
import {useLocation} from 'react-router-dom'
import { formatDate } from '../../../../utils/date'
import usePermission from '../../../../hook/usePermission'
import useGetJobData from '../../../jobs/hooks/useGetJobData'

const OrderAuditListHeader = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const view = searchParams.get('view')
  const [isClearInput, setIsClearInput] = useState(false)
  const [selectedSalesRep, setSelectedSalesRep] = useState('')
  const {onSearch, salesReps, isSalesRepDropdownLoading, onChangeSalesRepFilter} =
    useContext(OrderAuditContext)
  const {hasPermission} = usePermission()
  const {jobData, runTask, refetchJobData} = useGetJobData('refresh_all_order_audits')

  useEffect(() => {
    let intervalId: any = null

    if (jobData?.status === 'running') {
      intervalId = setInterval(() => {
        refetchJobData()
      }, 5000)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobData?.status === 'running', refetchJobData])

  useEffect(() => {
    setIsClearInput(true)
    setSelectedSalesRep('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view])

  // Reset clear input flag after it's been used
  useEffect(() => {
    if (isClearInput) {
      setIsClearInput(false)
    }
  }, [isClearInput])

  return (
    <header className='d-flex justify-content-between'>
      <div className='d-flex align-items-end gap-10 mb-10'>
        <Search onSearch={onSearch} isClearInput={isClearInput} />
        <Select
          id={`sales-rep-filter`}
          label='Sales Rep'
          options={salesReps}
          className='w-175px'
          placeholder='Select Sales Rep'
          isNullable={true}
          isLoading={isSalesRepDropdownLoading}
          value={selectedSalesRep}
          onChange={(e: any) => {
            setSelectedSalesRep(e.target.value)
            onChangeSalesRepFilter(e.target.value)
          }}
        />
      </div>
      {hasPermission('settings_jobs', 'write') && (
        <div className='position-relative d-flex align-items-center'>
          <span className='me-2'>Last Sync:</span>
          <span className='me-3'>{formatDate(jobData.last_run_end_time, false)} </span>
          {jobData?.status !== 'running' ? (
            <>
              {
                <i
                  className='fas fa-sync cursor-pointer fs-5'
                  onClick={() => runTask('refresh_all_order_audits')}
                ></i>
              }
            </>
          ) : (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border text-success' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
            </div>
          )}
        </div>
      )}
    </header>
  )
}

export default OrderAuditListHeader
